module.exports = __webpack_public_path__ + "static/media/team-2.886b2d99.webp";